import React, { Component } from 'react';
// import MImg from '@/components/img';
// 域名及加载中图片映射关系
const Domain2Img = {
  // 墨西哥
  'kabilcash.com': 'mexico.gif',
  'creavicash.com': 'mexico.gif',
  'ipeso.cc': 'mexico.gif',
  'maxcredito.cc': 'mexico.gif',
  'mcredito.cc': 'mexico.gif',
  'justocredito.com': 'mexico.gif',

  // 尼日利亚
  'credit9ja.cc': 'nigeria.webp',
  'xcredit.cc': 'nigeria.webp',
  'imoney.ng': 'nigeria.webp',

  // 乌干达
  'ucredit.cc': 'nigeria.webp',
  'mangucash.com': 'nigeria.webp',
  'www.mangucash.com': 'nigeria.webp',

  // 肯尼亚
  'kashway.cc': 'kenya.gif',
  'ipesa.cc': 'kenya.gif',

  // 分控数据包
  'mocash.cc': 'nigeria.webp',

  // 分控数据包
  'creditmoja.com': 'kenya.gif',
  'www.creditmoja.com': 'kenya.gif',
  
  // 秘鲁
  'isolez.cc': 'peru.gif',
  'cajaplatinka.com': 'peru.gif',
  'www.cajaplatinka.com': 'peru.gif',

  'testhk4.xcreditech.com': 'kenya.gif',
  'testhk10.xcreditech.com': 'peru.gif',
  'testhk11.xcreditech.com': 'peru.gif',

  'testhk14.xcreditech.com': 'wait.gif',
  'testhk15.xcreditech.com': 'peru.gif',
  'parcecredit.com': 'peru.gif',
  'www.parcecredit.com': 'peru.gif',

  'champloan.com': 'wait.gif',
  'www.champloan.com': 'wait.gif',
  'localhost:3000': 'wait.gif',
}
class FirstScreen extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }
  render () {
    const host = window.location.host
    const msHost = [
      'testhk14.xcreditech.com',
      'champloan.com',
      'www.champloan.com',
    ]
    const img = Domain2Img[host] || 'kenya.gif'; // 默认英语及肯尼亚gif
    // webview未必给权限 所以不能给直接使用localStorage.setItem
    // 故未使用$t
    let title = 'Page loading, please wait...';
    if (img.includes('mexico') || img.includes('peru') || msHost.includes(host)) {
      title = 'Página cargada, por favor más tarde...';
    }
    return (
      <div className='first-screen'>
        <div className='loading'>
          <div className="img-box">
            <img alt="MIB" src={ window.$localCdnLink + '/loading/' + img } />
          </div>
          <p>{ title }</p>
        </div>
      </div>
    )
  }
}
export default FirstScreen